<template>
  <div>
    <div class="uiBreadcrumb">
      <ul class="uiClrfix" v-if="lang == 'chs'">
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />首页</a>
        </li>
        <li><span>/</span><a class="cur">关于</a></li>
      </ul>
      <ul class="uiClrfix" v-else>
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />Home</a>
        </li>
        <li><span>/</span><a class="cur">About</a></li>
      </ul>
    </div>
    <div class="center">
      <div class="about_main" v-if="lang == 'chs'">
        <h3 class="about_main_title">{{ mianText.title }}</h3>
        <div style="margin-bottom: 17px">{{ mianText.text1 }}</div>
        <div>{{ mianText.text2 }}</div>
      </div>
      <div class="about_main" v-else>
        <h3 class="about_main_title">{{ mianText.titleE }}</h3>
        <div style="margin-bottom: 17px">{{ mianText.text1E }}</div>
        <div>{{ mianText.text2E }}</div>
      </div>
      <div class="icon_box hidden">
        <a
          href="https://www.facebook.com/share.php?&u=https%3A%2F%2Fwww.waterwood.hk%2Fa-list%2F6831-chs&t=%E5%85%B3%E4%BA%8E-%E6%B0%B4%E6%9C%A8%E6%8A%95%E8%B3%87%E7%AE%A1%E7%90%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8" target=“_blank”
        >
          <svg-icon class="facebook icon" icon-class="facebookfacebook52" />
        </a>
        <a
          href="https://service.weibo.com/share/share.php?url=https%3A%2F%2Fwww.waterwood.hk%2Fa-list%2F6831-chs&title=%E5%85%B3%E4%BA%8E-%E6%B0%B4%E6%9C%A8%E6%8A%95%E8%B3%87%E7%AE%A1%E7%90%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&searchPic=false#_loginLayer_1685435066912" target=“_blank”
        >
          <svg-icon class="weibo icon" icon-class="weibo" />
        </a>
        <span @click="toShowWeixin()">
          <svg-icon class="weixin icon" icon-class="weixin" />
        </span>
        <span @click="toShowApp()">
          <svg-icon class="dianhua icon" icon-class="dianhua" />
        </span>
        <svg-icon
          class="dayin icon"
          icon-class="piaojudayinji"
          v-print="print"
        />
        <div class="icon_text" v-if="lang == 'chs'">分享给朋友</div>
        <div class="icon_text" v-else>Share to friends</div>
        <div class="icon_text text_right" v-if="lang == 'chs'">打印</div>
        <div class="icon_text text_right" v-else>Print</div>
        <div class="weixin_dialog" v-if="weixinShow">
          <div class="dialog_close" @click="closeWeixin()"></div>
          <div v-if="lang == 'chs'">
            <div class="dialog_title">分享至微信好友和朋友圈</div>
            <img src="../assets/images/aboutc.png" alt="" />
            <div class="dialog_text">用微信扫描二维码</div>
            <div class="dialog_text">分享至微信好友和朋友圈</div>
          </div>
          <div v-else>
            <div class="dialog_title">Share to Friends or post on Moments</div>
            <img src="../assets/images/aboute.png" alt="" />
            <div class="dialog_text">Open WeChat app and scan the QR code</div>
            <div class="dialog_text">Share - WeChat</div>
          </div>
        </div>
        <div class="app_dialog" v-if="AppShow">
          <div class="dialog_close" @click="closeApp()"></div>
          <div v-if="lang == 'chs'">
            <div class="dialog_title">转发至WhatsApp</div>
            <div class="dialog_text">
              <div class="setp">第一步</div>
              <div class="content">
                点击打开以下网址
                <a href="http://web.whatsapp.com">
                  <span>http://web.whatsapp.com</span>
                </a>
              </div>
            </div>
            <div class="dialog_text">
              <div class="setp">第二步</div>
              <div class="content">以WhatsApp手机客户端扫描登入网页版</div>
            </div>
            <div class="dialog_text">
              <div class="setp">第三步</div>
              <div class="content">
                拷贝本活动网址于WhatsApp网页版对话框发送
              </div>
            </div>
          </div>
          <div v-else>
            <div class="dialog_title">Share to WhatsApp</div>
            <div class="dialog_text">
              <div class="setp">Setp 1</div>
              <div class="content">
                Click to open the following website:
                <a href="http://web.whatsapp.com">
                  <span>http://web.whatsapp.com</span>
                </a>
              </div>
            </div>
            <div class="dialog_text">
              <div class="setp">Setp 2</div>
              <div class="content">Sign in the web version of WhatsApp</div>
            </div>
            <div class="dialog_text">
              <div class="setp">Setp 3</div>
              <div class="content">
                Copy the URL of this event and send it in the WhatsApp webpage
                dialog box
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "About",
  data() {
    return {
      lang: "",
      mianText: {
        title: "关于",
        titleE: "About",
        text1:
          "水木基金是专注于医疗、科技及新型经济产业发展、整合和并购投资机会的股权私募基金，其投资团队成员包括来自跨国投资银行、私募和创投基金及法律会计专业领域的人士。",
        text1E:
          "Waterwood is a private equity firm that invests in growth stage, industry consolidation and M&A opportunities in the healthcare, technology and new economy sectors. Its investment team comprises experienced executives and professionals from international investment banks, private equity and venture capital houses, and accounting and legal practices.",
        text2:
          "水木基金的投资者主要是家族办公室和机构投资者。为配合这些机构投资者的资产配置和回报要求，水木基金将着重寻找被关注行业内的中外领先企业，判断该些企业在经济周期和行业整合中抵御风险和把握机会的能力，配合水木基金投资团队的人脉、行业、企业管理及并购的经验和资源，在适当时候向被选定的企业投放显著的资金，让企业能够利用资本杠杆和金融效率锐变，抛离竞争对手、整合产业格局或颠覆行业的既有持分者，成为行业的龙头或开创更有利自己发展的市场空间。为配合这投资战略，水木基金会比较倾向投资于成长期的企业，一般会在被投资的企业占董事席位，主动帮助企业拓展业务，争取在中期退出并取得丰厚回报。",
        text2E:
          "Investors of Waterwood are mostly family offices and other institutional investors. To achieve the asset allocation and investment return expected by our investors, Waterwood focuses on identifying Chinese and overseas leaders in its sectors of interest and assess their ability to tackle challenges and capture opportunities through economic cycles. It seeks to deploy significant amount of capital at the right time to enable its portfolio companies to accelerate capital efficiency. In its active investment practice, Waterwood engages its portfolio companies in exploring its critical resources in business network, domain knowledge, corporate management experience, and M&A expertise. We encourage our partner entrepreneurs to fully leverage our commitments to outperform competitors, redefine industry landscape, and disrupt vested interests to become the winners and open up new business horizon. When executing this investment strategy, Waterwood generally prefers growth stage investment opportunities that can effectively deploy capital from Waterwood. We normally require board seat that allows us to take proactive steps to contribute to the development of our portfolio companies and generate significant return in midterm.",
      },
      weixinShow: false,
      AppShow: false,
      print: {
        id: 'printBill',
        popTitle: '关于-水木投資管理有限公司', // 打印配置页上方的标题
        previewTitle: '关于-水木投資管理有限公司', // 打印预览的标题
        zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
        standard: '',
        extarCss: ''
      }
    };
  },
  methods: {
    //展示微信弹窗
    toShowWeixin() {
      this.weixinShow = true;
    },
    //关闭微信弹窗
    closeWeixin() {
      this.weixinShow = false;
    },
    //展示whatsapp弹窗
    toShowApp() {
      this.AppShow = true;
    },
    //展示whatsapp弹窗
    closeApp() {
      this.AppShow = false;
    },
  },
  mounted() {
    let lang = sessionStorage.getItem("lang");
    if (lang) {
      this.lang = lang;
      this.$store.commit("setLang", lang);
    } else {
      this.lang = "chs";
      this.$store.commit("setLang", "chs");
    }
  },
  computed: {
    listenData() {
      return this.$store.state.lang;
    },
  },
  watch: {
    listenData(newVal) {
      this.lang = newVal;
    },
  },
};
</script>

<style scoped>

@media print {
  .hidden{
      display: none;
  }

}
.uiBreadcrumb {
  width: 1200px;
  padding: 0 15px;
  margin: 15px auto;
  height: 19px;
}

.uiBreadcrumb ul li {
  float: left;
}

.uiBreadcrumb ul li:nth-child(1):hover a {
  color: #233a78;
}

.uiBreadcrumb ul li span {
  padding: 0 5px;
}

.uiBreadcrumb ul li a {
  color: #999;
  font-size: 14px;
}

.uiBreadcrumb ul li .cur {
  color: #333;
  font-size: 14px;
}
.center {
  width: 1200px;
  margin: auto;
  background: #fff;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.about_main {
  margin-top: 30px;
  min-height: 260px;
  line-height: 27px;
  padding: 60px 230px 90px;
  font-size: 18px;
}
.about_main_title {
  padding: 20px 0 30px;
}
.icon_box {
  position: relative;
  padding: 20px 230px 100px;
  font-size: 36px;
  color: #ccc;
}
.icon {
  margin: 0 5px;
  cursor: pointer;
  color: #ccc;
}

.facebook:hover {
  color: #2F4D9F;
}
.weibo:hover {
  color: #f00;
}
.weixin:hover {
  color: #95ec69;
}
.dianhua:hover {
  color: #19c9ac;
}
.dayin {
  float: right;
}
.dayin:hover {
  color: #666;
}
.icon_text {
  font-size: 16px;
}
.text_right {
  float: right;
  width: 46px;
  text-align: center;
  margin-top: -24px;
}
.weixin_dialog {
  position: absolute;
  bottom: 180px;
  left: 320px;
  width: 210px;
  min-height: 280px;
  padding: 30px;
  background: #fff;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.app_dialog {
  position: absolute;
  bottom: 180px;
  left: 350px;
  width: 280px;
  min-height: 120px;
  padding: 30px;
  background: #fff;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.dialog_title {
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  color: #000;
}
.dialog_text {
  font-size: 12px;
  line-height: 22px;
  color: #666;
}
.dialog_text a {
  color: #4099FF;
}
.setp {
  float: left;
  width: 60px;
  font-weight: bold;
}
.content {
  float: left;
  width: 220px;
}

.dialog_close {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 14px;
  height: 14px;
  background-image: url("../assets/images/close.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
}
</style>